// Shared constants and helpers for the Case Review feature.

export const DISPOSITION_OPTIONS = [
    'Pending Case Creation',
    'Working',
    'Resolved-Inventory or Refund Processed',
    'Concluded - No Credit',
    'Need additional photos'
];

export const STATUS_COLORS = {
    'Need additional photos': { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-500', dot: 'bg-red-500', borderColor: '#ef4444' },
    'Pending Case Creation': { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-500', dot: 'bg-yellow-500', borderColor: '#eab308' },
    'Working': { bg: 'bg-blue-100', text: 'text-blue-800', border: 'border-blue-500', dot: 'bg-blue-500', borderColor: '#3b82f6' },
    'Resolved-Inventory or Refund Processed': { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-500', dot: 'bg-green-500', borderColor: '#22c55e' },
    'Concluded - No Credit': { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-500', dot: 'bg-gray-500', borderColor: '#6b7280' }
};

// Short labels for the compact stat cards.
export const STATUS_SHORT_LABEL = {
    'Resolved-Inventory or Refund Processed': 'Resolved',
    'Pending Case Creation': 'Pending',
    'Need additional photos': 'Need Photos',
    'Concluded - No Credit': 'No Credit',
    'Working': 'Working'
};

export const STATUS_PRIORITY = {
    'Need additional photos': 1,
    'Pending Case Creation': 2,
    'Working': 3,
    'Resolved-Inventory or Refund Processed': 4,
    'Concluded - No Credit': 5
};

export function getStatusColor(status) {
    return STATUS_COLORS[status] || STATUS_COLORS['Concluded - No Credit'];
}

export function formatDate(dateString) {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
}

// Parse a case's qr_case_data JSON exactly once and cache the result on the
// object as `parsedData`. Avoids re-parsing the same blob on every render.
export function withParsedData(caseItem) {
    let parsedData = {};
    if (caseItem.qr_case_data) {
        try {
            parsedData = JSON.parse(caseItem.qr_case_data) || {};
        } catch (e) {
            parsedData = {};
        }
    }
    return { ...caseItem, parsedData };
}

export function daysOpen(createdAt) {
    if (!createdAt) return 0;
    return Math.floor((Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24));
}

export function daysOpenBadgeColor(days) {
    if (days > 14) return 'bg-red-100 text-red-800';
    if (days > 7) return 'bg-orange-100 text-orange-800';
    if (days > 3) return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
}
